import React from 'react'

const OfferCard = ({image,content}) => {
  return (
    <div>
        <div className='w-full bg-white group rounded-md shadow-md overflow-hidden '>
            <img src={image} className='rounded-md hover:cursor-pointer transition-transform duration-300 group-hover:scale-105 ' alt="" />
            <div className='w-full p-3 h-32'>
                <p className='text-md font-semibold text-rose-500'>{content}</p>
                <p className='text-right'>T&C Apply</p>
            </div>
            <div className='w-full flex justify-between items-center p-2 border border-transparent border-t-gray-web'>
                <div className='text-green-500 text-sm font-semibold'>VALID TILL 31 JUL 2022</div>
                <div className='text-xs font-semibold text-blue-500'><a href="/">View Details</a></div>
            </div>
        </div>
    </div>
  )
}

export default OfferCard